import React, { useState } from "react";
import { Container, Box, Grid, Collapse } from "@material-ui/core";
import { Apps as SwissGroupGalleryIcon } from "@material-ui/icons";
import clsx from "classnames";

import ButtonSmg from "../ButtonSmg";
import EmergencyNumberBar from "../EmergencyNumberBar";
import LinkEcco, { WrappedLinkRouter } from "../Link";
import { SwissGroupGallery } from "../SwissGroupGallery";
import HeaderMenu from "../HeaderMenu";

import { useStyles } from "../../hooks";
import styles from "./styles";

import { WEBPAGE } from "../../main_config";
import menuItems from "../../data/menu_links";
import menuOptions from "../../data/info_header_menu";
import HeaderOption from "../HeaderOption";
import { EccoColor } from "../../components/Icons";

const Header = () => {
  const classes = useStyles(styles);
  const [selectedHeaderItem, setselectedHeaderItem] = useState("");
  const [selectedHeaderOption/*, setSelectedHeaderOption*/] = useState(
    menuOptions[0].value
  );

  const renderMenuOptions = () => (
    <HeaderOption
      title={selectedHeaderOption}
      elements={menuOptions}
      fixed={true}
      id={`headerMenuOptions`}
    />
  );

  const renderTopIcons = () => (
    <Grid container>
      <Grid item md={12} className={classes.topIconsContainer}>
        <Grid container justify="flex-end" alignItems="center">
          <Box
            display="flex"
            justifyContent="flex-end"
            flex={1}
            className={classes.eccoLinks}
          >
            <Box
              component="span"
              marginRight="4px"
              marginTop="9px"
              letterSpacing={0.2}
            >
              Estoy en el sitio de:&nbsp;
            </Box>
            {renderMenuOptions()}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );

  const renderLinks = () => {
    return (
      <Box
        display="flex"
        justifyContent="flex-end"
        flex={1}
        className={classes.eccoLinks}
      >
        {
          menuItems.filter(menu => menu.key !== "productos/consulta")
            .map(menu => (
              <HeaderMenu
                key={menu.key}
                item={menu}
                onClick={setselectedHeaderItem}
              />
            ))
        }
      </Box>
    );
  };

  // const renderHeaderMenuContent = () => {

  // }

  // const renderHeaderMenuSites = () => {

  // }

  // const renderMobile = () => {

  // }

  return (
    <Box
      className={classes.root}
      onMouseLeave={() => setselectedHeaderItem("")}
    >
      <EmergencyNumberBar />
      <Box className={classes.contentWrap}>
        {renderTopIcons()}
        <Box
          display="flex"
          alignItems="center"
          className={classes.headerContainer}
        >
          <LinkEcco to="/" className={classes.eccoLogo}>
               <EccoColor  className={classes.logo}/>
          </LinkEcco> 
          {renderLinks()}
          <Box className={classes.eccoButtonsContainer}>
            <ButtonSmg
              id="btn-asociarme"
              theme="material"
              content="Quiero asociarme"
              variant="outlined"
              buttonNav
              buttonNav2
              component={LinkEcco}
              to={`${WEBPAGE}/productos/consulta`}
              url={`${WEBPAGE}/productos/consulta`}
              external={true}
              target="_blank"
            />
            <ButtonSmg
              id="btn-ingresar"
              theme="material"
              color="primary"
              content="Ingresar"
              buttonNav
              component={WrappedLinkRouter}
              to="/"
            />
          </Box>
          <Box
            className={clsx(classes.eccoLink, classes.swissGroupIconWrapped, {
              [classes.active]: selectedHeaderItem === "logos"
            })}
            role="presentation"
            onMouseEnter={() => setselectedHeaderItem("logos")}
          >
            <SwissGroupGalleryIcon fontSize="large" />
          </Box>
        </Box>
      </Box>
      <Collapse
        in={selectedHeaderItem === "logos"}
        timeout={{
          enter: 150,
          exit: 150
        }}
      >
        <Box className={classes.headerMenu}>
          <Container>
            <SwissGroupGallery />
          </Container>
        </Box>
      </Collapse>
    </Box>
  );
};

// Header.propTypes = {

// }

export default Header;
